exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#contenedorSeguimiento[data-v-2e354c04]{font:14px nunito,ligth-italic}#tituloDatosSeguimiento[data-v-2e354c04]{color:#646a6a;margin:0 0 .833vw 2%;font-size:1vw}#contenedorDatosSeguimientos[data-v-2e354c04]{width:100%;border-radius:.417vw}.grid[data-v-2e354c04]{display:grid;grid-template-columns:1fr 1fr 1fr;text-align:center}#contenedorSelect[data-v-2e354c04]{width:100%;margin:auto;align-items:center;padding:0 5%}.md-menu.md-select[data-v-2e354c04]{flex:1;overflow:auto;z-index:2;border:1px solid;border-radius:13px}.md-menu[data-v-2e354c04],.md-select[data-v-2e354c04]{display:flex;flex:1;overflow:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e354c04","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./src/components/DatosInicioSeguimiento/DatosInicioSeguimiento.css
// module id = 848
// module chunks = 0